import { cacheExchange, fetchExchange, mapExchange, Client } from 'urql';

import { GRAPH_QL_PATH } from '@/utils/constants';

export const gqlClient = new Client({
  exchanges: [
    cacheExchange,
    mapExchange({
      onError: async (error) => {
        const authError = error.graphQLErrors.some(
          (err) => err.extensions?.code === 'UNAUTHENTICATED',
        );

        if (authError) {
          window.location.href = '/logout';
        }
      },
    }),
    fetchExchange,
  ],
  fetchOptions: { credentials: 'include' },
  url: GRAPH_QL_PATH,
});
